import { createStoreForProduct } from './ProductStore'

export const HighwayForecastStore = createStoreForProduct('highwayforecast')
